var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('b-button',{attrs:{"size":"sm","variant":"primary","to":{ name: _vm.routeName },"aria-label":"Group Message"}},[_c('i',{staticClass:"fa fa-bullhorn"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }